module.exports = __webpack_public_path__ + "img/2.974d00ae.png";